module.exports = __webpack_public_path__ + "img/banner1.af13eac2.png";